import type { Story, FamilyGroupWithMembers } from '../types';

interface UserProfileShape {
  firstName: string | null;
  lastName: string | null;
  secondLastName: string | null;
}

// Pure predicate functions used by the prompt orchestrator. Kept here so
// each prompt's "should this fire?" rule is testable in isolation and the
// orchestrator priority logic stays trivial.

export interface OnboardingState {
  loaded: boolean;
  stepsCompleted: Record<number, boolean>;
}

// Tutorial dominates everything else until the user has progressed past
// the LAST onboarding step. After the 2026-05-03 renumber, step 6 is the
// final "Tu panel de historias" StoryRecorder modal — gate on that, not
// step 5 (which is now the in-overlay Siguiente tooltip and fires earlier).
export const isTutorialActive = (onboarding: OnboardingState): boolean => {
  if (!onboarding.loaded) return false;
  return !onboarding.stepsCompleted[6];
};

// Audience-invite nudge — appears when the user is the sole member of the
// active family AND has progressed enough that there is something worth
// sharing. Cristian's milestone: "first chapter complete." A precise check
// requires loading per-story `story_questions`; here we use the
// story.progress proxy. 1 chapter ≈ 5 of 42 questions ≈ 12% progress on
// the (optional-aware) RPC counter, so progress ≥ 12 is close enough.
export const isAudienceInviteEligible = (
  activeFamily: FamilyGroupWithMembers | null,
  stories: Story[],
): boolean => {
  if (!activeFamily) return false;
  if ((activeFamily.members?.length ?? 0) !== 1) return false;
  return stories.some(s => (s.progress ?? 0) >= 12);
};

export const isIncompleteProfileEligible = (
  userProfile: UserProfileShape | null,
): boolean => {
  if (!userProfile) return false;
  return !userProfile.firstName || !userProfile.lastName;
};
